import React from 'react';
import cl from "./FormBlock.module.css";
import {Paper, SvgIcon} from "@mui/material";
import InlineTip from "../components/InlineTip";
import {inlineTipMargin} from "../AppVars";

// mode: "normal"|"warn"
const FormBlock = ({title, children, subTitle, mode = "normal", tipText}) => {
    return (
        <Paper variant="outlined" sx={{
            backgroundColor: (mode === "warn" ? "#e0e0d0" : "#e8e8e8"),
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "15px"
        }}>
            {title && <p className={`${cl.title} ${mode === "warn" ? cl.warn : ""}`}>
                {mode === "warn" && renderWarnIcon()}
                {title}
                {tipText && <InlineTip text={tipText} style={{marginLeft:`${inlineTipMargin}px`}}/>}
            </p>}
            {subTitle && <p className={`${cl.subTitle} ${mode === "warn" ? cl.warn : ""}`}>{subTitle}</p>}
            {children}
        </Paper>
    );

    function renderWarnIcon() {
        return <SvgIcon sx={{marginTop: "-10px", marginBottom: "-5px"}}>
            <svg fill={"#ed6c02"}>
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
                />
            </svg>
        </SvgIcon>
    }
};

export default FormBlock;